module.exports = __webpack_public_path__ + "static/media/muhammad_faishal.5e4cf7a9.jpg";